import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/examenes-medicos/';

/**
 * GET ExamenesMedicos
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getExamenesMedicos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Examene Medico
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getExameneMedico = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Examen Medico
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postExameneMedico = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Examen Medico
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchExameneMedico = async (id, _values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, _values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Examen Medico
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteExameneMedico = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
